// extracted by mini-css-extract-plugin
export default {"ccDisabled":"#e0e0e0","ccDisabledText":"#a0a0a0","ccLime":"#cfff5e","ccBlue":"#2b2bb5","ccDarkBlue":"#09003d","ccTurquoise":"#c2c2c2","ccLightPurple":"#c78fff"};